import FileSaver from "file-saver";
import XLSX from "xlsx";
/* 从表生成工作簿对象 */
export function exportExcel(tableID) {
    let table = document.querySelector("#"+tableID).cloneNode(true);
    // 因为element-ui的表格的fixed属性导致多出一个table，会下载重复内容，这里删除掉
    if(table.querySelector(".el-table__fixed-right")){
        table.removeChild(table.querySelector(".el-table__fixed-right"))
    }
    if(table.querySelector(".el-table__fixed")){
        table.removeChild(table.querySelector(".el-table__fixed"))
    }
    
    let wb = XLSX.utils.table_to_book(table,{raw:true});//mytable为表格的id名
    /* get binary string as output */
    let wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
    });
    try {
        FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
                "sheet.xlsx"
        );
    } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
    }
    return wbout;
}


// WEBPACK FOOTER //
// ./src/util/downLoad.js